import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { viewsPlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import { useSetRangeDefaultValue } from '../../hooks/init';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import './index.scss';
export default function ViewsSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: SingleCommonType) {
  const { formatMessage } = useIntl();

  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      defaultKey: 'views',
      subDefaultKey: 'views',
      oriDefaultFilter,
      backOriDefaultValue,
      options: [
        { text: 'All', value: '-' },
        { text: '0 ~ 50K', value: '0-50' },
        { text: '50K ~ 100K', value: '50-100' },
        { text: '100K ~ 500K', value: '100-500' },
        { text: '500K ~ 1M', value: '500-1000' },
        { text: '1M+', value: '1000-' },
      ],
    });

  useEffect(() => {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start, end] = rangeValue.split('-');
      let dataItem: { start_views: number; end_views?: number } = {
        start_views: Number(start) * 1000,
      };
      if (end !== '') {
        dataItem['end_views'] = Number(end) * 1000;
      }
      data.push(dataItem);
    }

    onChange?.('views', commonBackInfo({ views: data }, { views: showHeader }));
  }, [rangeValue, formatMessage]);

  return (
    <div className={`dbo-views-wrapper ${diffClassName}`}>
      <CustomFollowerRange
        lang={lang}
        ref={followerRef}
        options={options}
        setRangeValue={setRangeValue}
        rangeValue={rangeValue}
        placeholder={viewsPlaceholder}
        pointKey={FilterButtonPoint.views}
      ></CustomFollowerRange>
    </div>
  );
}
